import { IQuickLink } from '../../../containers/QuickLinksContainer/types';

export const MORE_BUTTON_LENGTH = 48;
export const LINK_SYMBOL_LENGTH = 8;
export const LINK_GAP = 4;
export const LINKS_GAP = 16;

function getLinkLength(link: IQuickLink): number {
  const titleLength = link.title.length;
  const counterLength = link.counter.toString().length;

  return titleLength * LINK_SYMBOL_LENGTH + LINK_GAP + counterLength * LINK_SYMBOL_LENGTH;
}

function getLinkItemWidth(link: IQuickLink): number {
  return getLinkLength(link) + LINKS_GAP;
}

function countItemsInRow(availableWidth: number, itemWidths: number[]): number {
  let usedWidth = 0;
  let count = 0;

  for (const itemWidth of itemWidths) {
    const gap = count > 0 ? LINKS_GAP : 0;

    if (usedWidth + gap + itemWidth > availableWidth) {
      break;
    }

    usedWidth += gap + itemWidth;
    count++;
  }

  return count;
}

export function packLinksInTwoRows(
  blockWidth: number,
  itemWidths: number[],
  moreButtonWidth: number = MORE_BUTTON_LENGTH,
): number {
  if (itemWidths.length === 0 || blockWidth <= 0) {
    return 0;
  }

  const row1Count = countItemsInRow(blockWidth, itemWidths);
  const remainingWidths = itemWidths.slice(row1Count);
  const row2CountFull = countItemsInRow(blockWidth, remainingWidths);

  if (row1Count + row2CountFull >= itemWidths.length) {
    return itemWidths.length;
  }

  const row2AvailableWidth = blockWidth - LINKS_GAP - moreButtonWidth;
  const row2CountWithMore = countItemsInRow(row2AvailableWidth, remainingWidths);

  return row1Count + row2CountWithMore;
}

export function getLinksLengthForTwoRows(blockWidth: number, links: IQuickLink[]): number {
  const itemWidths = links.map(getLinkLength);

  return packLinksInTwoRows(blockWidth, itemWidths);
}

export function getLinksLength(
  blockWidth: number,
  links: IQuickLink[],
  { reserveMoreButtonSpace = false }: { reserveMoreButtonSpace?: boolean } = {},
): [length: number, count: number] {
  const availableWidth = reserveMoreButtonSpace ? blockWidth - MORE_BUTTON_LENGTH - LINKS_GAP : blockWidth;
  let linksWidth = 0;
  let linksCount = 0;

  for (const link of links) {
    const linkLength = getLinkItemWidth(link);

    if (linksWidth + linkLength > availableWidth) {
      break;
    }

    linksWidth += linkLength;
    linksCount++;
  }

  if (reserveMoreButtonSpace) {
    return [linksWidth + MORE_BUTTON_LENGTH + LINKS_GAP, linksCount];
  }

  return [linksWidth, linksCount];
}
